import { ArrowUpRight, Check } from "lucide-react";
import { montessoriPage } from "../mock";
import PageShell from "./PageShell";
import PageHero from "./PageHero";
import Reveal from "./Reveal";
import RelatedPages from "./RelatedPages";
import PullQuote from "./PullQuote";
import SectionOrnament from "./SectionOrnament";

export default function MontessoriPage() {
  const { hero, blocks, note } = montessoriPage;

  return (
    <PageShell>
      {({ openEnquire }) => (
        <>
          <PageHero eyebrow={hero.eyebrow} title={hero.title} italic={hero.italic} image={hero.image} blurb={hero.blurb} />

          <section className="bg-white py-14 md:py-20">
            <div className="max-w-[1200px] mx-auto px-5 md:px-10">
              <div className="space-y-16 md:space-y-24">
                {blocks.map((b, i) => {
                  const reverse = i % 2 === 1;
                  return (
                    <article key={b.title} className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
                      <Reveal variant={reverse ? "right" : "left"} className={`md:col-span-6 ${reverse ? "md:order-2" : ""}`}>
                        <div className="relative aspect-[4/3] overflow-hidden">
                          <img src={b.image} alt={b.title} loading="lazy" className="w-full h-full object-cover img-lift" />
                          <div className="absolute inset-0 ring-1 ring-[rgba(184,148,86,0.25)]" />
                          <div className="hidden md:block absolute -top-3 -left-3 w-14 h-14 border-l-2 border-t-2 border-[var(--gold)]" />
                          <div className="hidden md:block absolute -bottom-3 -right-3 w-14 h-14 border-r-2 border-b-2 border-[var(--gold)]" />
                        </div>
                      </Reveal>
                      <Reveal variant={reverse ? "left" : "right"} delay={100} className="md:col-span-6">
                        <div className="eyebrow mb-3">0{i + 1} · Montessori</div>
                        <h3 className="serif text-[28px] md:text-[38px] leading-tight text-[var(--ink)]">
                          {b.title.split(" ")[0]}
                          <span className="block serif-italic gold-text">{b.title.split(" ").slice(1).join(" ")}</span>
                        </h3>
                        <span className="gold-divider-thin block my-5" />
                        <p className="text-[15px] md:text-[16.5px] leading-[1.85] text-[var(--ink)]/80">{b.body}</p>
                      </Reveal>
                    </article>
                  );
                })}
              </div>

              <Reveal>
                <div className="mt-16 md:mt-20 p-6 md:p-8 border border-[rgba(184,148,86,0.4)] bg-[var(--cream)]/60 text-center">
                  <div className="eyebrow mb-2">Note</div>
                  <p className="serif-italic text-[var(--ink)]/80 text-[16px] md:text-[18px]">{note}</p>
                </div>
              </Reveal>

              <Reveal>
                <div className="mt-12 md:mt-16 text-center">
                  <button onClick={openEnquire} className="btn-gold inline-flex items-center gap-2" style={{ background: "var(--gold)", color: "var(--navy-deep)" }}>
                    Enquire about Admissions <ArrowUpRight size={16} />
                  </button>
                </div>
              </Reveal>
            </div>
          </section>

          <PullQuote
            tone="dark"
            text="Follow the child. Free the child's potential, and you will transform him into the world."
            attribution="Maria Montessori"
          />

          <RelatedPages current="/montessori.html" />
        </>
      )}
    </PageShell>
  );
}
